import { useLoginWhoAmI } from "@crowdcoursing/api/openapi";
import { useMemo } from "react";

/** Matches API <c>RoleConstants.Sales</c> ("Sales"). */
const SALES_ROLE = "Sales";

/**
 * Bubble used for `/api/v1/sales/bubbles/{bubbleId}/…` calls.
 * Prefers a bubble where the user has the Sales role; otherwise (site admin) first bubble membership if any.
 */
export function useSalesBubbleId(): string | undefined {
  const { data: whoAmI } = useLoginWhoAmI({});

  return useMemo(() => {
    const bubbleRoles = whoAmI?.userDto?.bubbleRoles ?? [];
    const salesBubble = bubbleRoles.find((b) => b.role === SALES_ROLE);
    if (salesBubble?.bubbleId) {
      return salesBubble.bubbleId;
    }

    if (whoAmI?.isSiteAdmin && bubbleRoles[0]?.bubbleId) {
      return bubbleRoles[0].bubbleId;
    }

    return undefined;
  }, [whoAmI]);
}
